const AdminRouteNames = {
  ADMIN: 'admin',
  COURSES: 'admin-courses',
  SPECIALIZATIONS: 'admin-specializations',
  GROUP: 'admin-group',
  MY_GROUP: 'admin-my-group',
  OTHER_GROUP: 'admin-other-group',
  INSTITUTIONS: 'admin-institutions',
  PROGRAMS: 'admin-programs',
  ANALYTICS: 'admin-analytics',
} as const;

export const { GROUP, ANALYTICS } = AdminRouteNames;
